import { usePdfPageInfo } from "@/modules/publicQuote/components/PdfPageViewer";
import { PAGE_COUNTER_BASE_STYLE } from "./FpPageNumber";
import { counterMarginStyle } from "./pageCounterMargin";
import { useQuoteDocumentContext } from "./quoteDocumentContext";
import type { FpCommonProps } from "./types";

interface FpPageCountProps extends FpCommonProps {
  /** The authored `margin` shorthand, or null when unset. */
  margin?: string | null;
}

/**
 * Renders `<fp-page-count>`: the document's total page count, offset past cover
 * pages the same way `<fp-page-number>` is, so "Page 1 of 6" agrees with itself.
 * @param props - The counter's margin and common fp-* props
 * @returns A span containing the offset total page count
 */
export function FpPageCount({
  margin,
  className,
  style,
  "data-fp-node": dataFpNode,
}: FpPageCountProps) {
  const { totalPages } = usePdfPageInfo();
  const { footerPageOffset } = useQuoteDocumentContext();
  return (
    <span
      className={className}
      style={{
        ...PAGE_COUNTER_BASE_STYLE,
        ...counterMarginStyle(margin),
        ...style,
      }}
      data-fp-node={dataFpNode}
    >
      {totalPages - footerPageOffset}
    </span>
  );
}
